<template>
  <div class="morderApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px;"></div>
    
    <div class="scenicList">
      <img class="fmt" :src="baseUrl+setDetail.img" />
      <div class="con">
        <h2>{{setDetail.title}}</h2>
        <p>营业时间：{{setDetail.business}}</p>
        <p>近期浏览：{{setDetail.read_num}}次</p>
      </div>
      <div class="level">景区等级：<font>{{setDetail.level}}</font>
        <span @click="toPush(setDetail.id,'role')">超级管理员<img src="~assets/images/icon5.png"></i></span>
      </div>
    </div>
    
    <div class="parkData">
      <h2>
        <div>订单数据统计</div>
        <div class="amounts">
          <span>{{ticketTotal}} <font>({{years}}年数据)</font></span>
          <div class="tab">
            <a :class="years == 2025 ? 'curt' : ''" @click="ticketClick(2025)">2025年</a>
            <a :class="years == 2024 ? 'curt' : ''" @click="ticketClick(2024)">2024年</a>
            <a :class="years == 2023 ? 'curt' : ''" @click="ticketClick(2023)">2023年</a>
            <a :class="years == 2022 ? 'curt' : ''" @click="ticketClick(2022)">2022年</a>
            <!--<a :class="years == 2021 ? 'curt' : ''" @click="ticketClick(2021)">2021年</a>-->
          </div>
        </div>
      </h2>
      <div id="payment" style="height:180px;margin-top:30px"></div>
    </div>

    <div class="parkData">
      <h2>
        <div>景区订单明细</div>
        <div class="amounts">
          <span>{{setData.total}} <font>({{ys}}年数据)</font></span>
          <div class="tab">
            <a :class="ys == 2025 ? 'curt' : ''" @click="orderClick1(2025)">2025年</a>
            <a :class="ys == 2024 ? 'curt' : ''" @click="orderClick1(2024)">2024年</a>
            <a :class="ys == 2023 ? 'curt' : ''" @click="orderClick1(2023)">2023年</a>
            <a :class="ys == 2022 ? 'curt' : ''" @click="orderClick1(2022)">2022年</a>
          </div>
        </div>
      </h2>

      <div class="order-item" v-for="(item,i) in setData.rs">
        <div class="title">
          <div class="address">{{item.name}}</div>
          <div class="make">{{item.phone}}</div>
        </div>
        <div class="product">
          <div class="left">
            <div class="names">
              <div class="bt">{{item.title}}<span>×1</span></div>
              <div class="timer">使用时间:{{item.starttime}} 至 {{item.endtime}}</div>
              <div class="timer">支付时间:{{item.paytime}}</div>
              <div class="timer" >订单编号:{{item.number}}
                <span><i>￥</i><b>{{item.price}}</b>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>

    <div style="height:15px;"></div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setDetail:[],
        setData:[],
        ticketTotal:0,
        years:2025,
        ys:2025
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
      this.getTicket();
      this.ryOrder();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/index/spot',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data.data;
          that.setDetail = res;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      ticketClick:function(d){
        this.years = d;
        this.getTicket();
      },

      getTicket:function(e){
        var that = this;
        that.fullscreenLoading = true;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/index/yearOrder',
          params:{
            id:id,
            years:that.years
          }
        }).then(function(response){
          var res = response.data.data;
          that.ticketTotal = res.total
          that.payments(res);
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      payments:function(msg){
        var myChart = this.$echarts.init(document.getElementById('payment'));
        var option;
        option = {
          color:['#FFAA3B'],
          grid: {
            left:20,
            right:30,
            top:10,
            bottom:0,
            containLabel: true
          },
            xAxis: {
              type: 'category',
              data: msg.day,
              axisLine:{
              lineStyle:{
                color:'rgba(153,153,153,.1)'
              }
            },
            splitLine:{
              lineStyle:{
                color:'rgba(255,255,255,0)'
              }
            },
            axisLabel:{
              color:"rgba(153,153,153,1)"
            },
            boundaryGap: [0, 0.01]
            },
            yAxis: {
              type: 'value',
              axisLine:{
                lineStyle:{
                  color:'rgba(153,153,153,.1)'
                }
              },
              splitLine:{
                lineStyle:{
                  color:'rgba(153,153,153,.1)'
                }
              },
              axisLabel:{
                color:"rgba(153,153,153,1)"
              },
            },
            series: [{
              barWidth: 10,
              data: msg.nums,
              type: 'bar',
              itemStyle: {
              normal: {
                color: this.$echarts.graphic.LinearGradient(
                  1, 0, 0, 1,
                  [
                    {offset: 0, color: 'rgb(255,170,5)'},
                    {offset: 1, color: 'rgb(255,237,82)'}
                  ]
                ),
                barBorderRadius:[16, 16, 0, 0]
              }
            },
            label: {
              show: true,
              position: 'inside',
              valueAnimation: true,
              color:'#666666'
            },
          }]
        };
        option && myChart.setOption(option);
      },
      orderClick1:function(d){
        this.ys = d;
        this.ryOrder();
      },
      ryOrder:function(){
        var id = this.$route.query.id
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/index/orderDetail',
          params:{
            id:id,
            years:that.ys
          }
        }).then(function(response){
          that.setData = response.data.data;
        }).catch(err=>{

        });
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .morderApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }

  .morderApp .scenicList{
    width:92%;
    margin:0 auto;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.01);
    background:#fff;
    border-radius:4px
  }
  .morderApp .scenicList img{
    float:left;
    width:35%;
    margin:10px;
    border-radius:4px
  }
  .morderApp .scenicList .con{
    float:left;
    width:55%;
    margin-top:10px;
  }
  .morderApp .scenicList .con h2{
    font-size:15px;
    color:#333;
    letter-spacing: 1px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .morderApp .scenicList .con p{
    font-size:14px;
    color:#666;
    margin-top:13px;
  }
  .morderApp .scenicList .level{
    clear:both;
    width:92%;
    margin:0 auto;
    font-size:15px;
    border-top:1px #fafafa solid;
    padding:10px 0 15px 0;
    color:#666
  }
  .morderApp .scenicList .level font{
    color:#f00;
    font-weight:bold;
  }
  .morderApp .scenicList .level span{
    float:right;
    font-size:12px;
    color:#999;
    margin-top:2px
  }
  .morderApp .scenicList .level span img{
    float:right;
    width:6px;
    margin:2px 0 0 8px
  }

  .morderApp .parkData{
    width:92%;
    margin:15px auto 0 auto;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.01);
    background:#fff;
    border-radius:4px;
    padding-bottom:20px
  }

  .morderApp .parkData h2{
    font-size:16px;
    width:92%;
    margin:0 auto;
    padding:15px 0 0 0;
    border-bottom:solid 1px #fafafa
  }
  .morderApp .parkData h2 i{
    float:right;
    font-size:14px;
    font-style: normal;
    font-weight:normal;
    color:#999
  }
  .morderApp .parkData h2 i img{
    width:6px;
    margin-left:5px
  }
  .morderApp .parkData h2 .amounts{
    padding:15px 0 7px 0;
  }
  .morderApp .parkData h2 .amounts span{
    font-size:22px
  }
  .morderApp .parkData h2 .amounts font{
    font-size:12px;
    color:#999;
    font-weight:normal;
    position: relative;
    top:-2px;
  }
  .morderApp .parkData h2 .amounts .tab{
    float:right;
    font-size:12px;
    color:#999;
    margin-top:8px
  }
  .morderApp .parkData h2 .amounts .tab a{
    font-size:12px;
    color:#666;
    margin-left:20px;
    font-weight:normal;
    position: relative;
  }
  .morderApp .parkData h2 .amounts .tab a.curt:after{
    position: absolute;
    content: '';
    background: #333;
    width:15px;
    height: 2px;
    border-radius: 2px;
    left: 50%;
    bottom: -10px;
    transform: translateX(-50%);
  }


  .morderApp .order-item{
    width: 92%;
    display: block;
    margin: 0px auto;
    border-bottom:solid 1px #EBF2FF;
    padding-bottom:10px;
  }
  .morderApp .order-item:last-child{
    border-bottom:none;
  }
  .morderApp .order-item .title{
    display: block;
    width:92%;
    margin:0 auto;
    padding-top:15px;
  }
  .morderApp .order-item .title .address{
    float: left;
    font-size: 15px;
    font-weight:bold;
  }
  .morderApp .order-item .title .make{
    float:right;
    font-size:14px;
    color:#406DE1;
  }
  .morderApp .order-item .product .left:after,.morderApp .order-item .btn:after{
    display:block;
    clear:both;
    content:"";
    visibility:hidden;
    height:0
  } 
  .morderApp .order-item .product .left .names{
    float:left;
    margin-left:4%;
    position:relative;
    width:96%;
  }
  .morderApp .order-item .product .left .names .bt{
    font-size: 15px;
    color: #000;
    width: 100%;
    height:45px;
    line-height: 45px;
  }
  .morderApp .order-item .product .left .names .bt span{
    float:right;
    color:#666;
    margin-right:15px;
    font-size:16px;
  }
  .morderApp .order-item .product .left .names .timer{
    font-size: 14px;
    color: #999;
    padding-bottom:10px;
  }
  .morderApp .order-item .product .left .names .timer span{
    float:right;
    color:#FF6600;
    margin-right:10px;
    font-size:16px;
    margin-top:-5px;
    font-weight:bold
  }
  .morderApp .order-item .product .left .names .timer span b{
    color: #f00;
    font-size:17px;
    font-weight:550;
  }

  .morderApp .order-item .product .left .names .timer span i{
    color: #f00;
    font-size:12px;
    font-style:normal
  }

</style>